import type {
    DripSequenceSortType,
    BroadcastSortType,
    NewsletterSortType,
    AudienceSortType,
    EditionStatus,
    CampaignStatus,
} from 'nutshell-graphql-types';
import type {
    GetAudiencesVariables as GetAudiencesQueryVariables,
    GetBroadcastsVariables as GetBroadcastsQueryVariables,
    GetNewslettersVariables as GetNewslettersQueryVariables,
    GetNewsletterEditionsVariables as GetNewsletterEditionsQueryVariables,
    GetDripSequenceEditionStubsVariables as GetDripSequenceEditionStubsQueryVariables,
    GetDripSequencesVariables as GetDripSequencesQueryVariables,
} from 'nutshell-graphql-types';

import {
    AUDIENCE_LIST_LIMIT,
    BROADCAST_LIST_LIMIT,
    NEWSLETTER_LIST_LIMIT,
    NEWSLETTER_EDITION_LIST_LIMIT,
    DRIP_SEQUENCE_LIST_LIMIT,
} from './constants';

export function getAudienceListQueryVariables({
    isArchived,
    sort,
    search,
    creatorUserId,
    lastUpdatedTime,
    onlyPublic,
}: {
    isArchived: boolean;
    sort: AudienceSortType;
    search: string | null | undefined;
    creatorUserId: string | null | undefined;
    lastUpdatedTime: string | null | undefined;
    onlyPublic: boolean;
}): GetAudiencesQueryVariables {
    return {
        limit: AUDIENCE_LIST_LIMIT,
        archived: isArchived,
        sort,
        search,
        creatorUserId,
        lastUpdatedTime,
        audienceTypeFilter: onlyPublic ? 'ONLY_PUBLIC' : 'ALL',
    };
}

export function getBroadcastListQueryVariables(
    isArchived: boolean,
    sort: BroadcastSortType,
    search?: string | null,
    creatorUserId?: string | null,
    lastUpdatedTime?: string | null,
    statuses?: EditionStatus[] | null,
    assigneeIds?: string[] | null
): GetBroadcastsQueryVariables {
    return {
        limit: BROADCAST_LIST_LIMIT,
        archived: isArchived,
        sort,
        search,
        creatorUserId,
        lastUpdatedTime,
        statuses,
        assigneeIds,
    };
}

export function getNewsletterListQueryVariables(
    isArchived: boolean,
    sort: NewsletterSortType,
    search?: string | null,
    creatorUserId?: string | null,
    lastUpdatedTime?: string | null,
    statuses?: CampaignStatus[] | null
): GetNewslettersQueryVariables {
    return {
        limit: NEWSLETTER_LIST_LIMIT,
        archived: isArchived,
        sort,
        search,
        creatorUserId,
        lastUpdatedTime,
        statuses,
    };
}

export function getDripSequenceListQueryVariables(
    isArchived: boolean,
    sort: DripSequenceSortType,
    search?: string | null,
    creatorUserId?: string | null,
    lastUpdatedTime?: string | null,
    statuses?: CampaignStatus[] | null
): GetDripSequencesQueryVariables {
    return {
        limit: DRIP_SEQUENCE_LIST_LIMIT,
        archived: isArchived,
        sort,
        search,
        creatorUserId,
        lastUpdatedTime,
        statuses,
    };
}

export function getNewsletterEditionListQueryVariables(
    newsletterId: string,
    isArchived?: boolean
): GetNewsletterEditionsQueryVariables {
    return {limit: NEWSLETTER_EDITION_LIST_LIMIT, newsletterId, isArchived};
}

export function getDripSequenceEditionStubsQueryVariables(
    dripSequenceId: string,
    isArchived?: boolean
): GetDripSequenceEditionStubsQueryVariables {
    return {limit: NEWSLETTER_EDITION_LIST_LIMIT, dripSequenceId, isArchived};
}
